/* eslint-disable  */
import { PlusOutlined } from '@ant-design/icons';

import { Button, Divider, Dropdown, Typography } from 'antd';
import { Link, useNavigate } from 'react-router-dom';

import { DownArrowHead } from '../../Assets';
import { LINKS } from '../../clientUtils';
import { USER_ROLE_KEY } from '../../constants';
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
// const AddSoOptions = () => {
//   const navigate = useNavigate();
//   return (
//     <Menu>
//       <Menu.Item onClick={() => navigate('/sales/so/create')}>Domestic Online</Menu.Item>
//     </Menu>
//   );
// };

// const AddSoGRNOptions = () => {
//   const navigate = useNavigate();
//   return (
//     <Menu>
//       <Menu.Item onClick={() => navigate('/sales/grn/online/create')}>Domestic Online</Menu.Item>
//     </Menu>
//   );
// };

const TableHeaders = ({ type }) => {
  const navigate = useNavigate();
  // const [user, setUser] = useState();
  const { user } = useAuth0();

  // useEffect(() => {
  //   const getUser = async () => {
  //     const res = await oktaAuth.getUser();
  //     setUser(res);
  //   };
  //   const u = oktaAuth.storageManager.getTokenStorage().getStorage()?.idToken?.claims;
  //   setUser(u);
  //   if (!u) getUser();
  // }, []);

  const purchaseRequestMenuItems = [
    {
      key: 'domestic',
      label: <a href="/purchases/purchase-request/domestic/create">FG Domestic</a>
    },
    {
      key: 'international',
      label: <a href="/purchases/purchase-request/international/create">FG International</a>
    }
  ];

  const purchaseReturnOrderMenuItems = [
    {
      key: 'international',
      label: <a href="/purchases/return-order/domestic">FG Domestic</a>
    }
  ];

  const AddCpoOptions = [
    {
      key: 'domestic_online',
      label: <a href="/sales/customer-po/online/create">Domestic Online</a>
    },
    {
      key: 'domestic_online-excess',
      label: <a href="/sales/customer-po/online-excess/create">Domestic Online Excess</a>
    }
  ];

  const asnMenu = [
    {
      key: 'domestic_online',
      label: <a href="/purchases/asn/domestic/create">FG Domestic</a>
    },
    {
      key: 'export_online',
      label: <a href="/purchases/asn/international/create">FG International</a>
    }
  ];
  const grnMenu = [
    {
      key: 'international_GRN',
      label: <a href="/purchases/grn/international/create">FG International</a>
    }
  ];
  const domesticSoMenu = [
    {
      key: 'domestic_online',
      label: <a href="/sales/domestic-sales-order/domestic-online/create">Domestic Online</a>
    },
    {
      key: 'domestic_offline',
      label: <a href="/sales/domestic-sales-order/domestic-offline/create">Domestic Offline</a>
    },
    {
      key: 'internal-stock-transfer',
      label: <a href="/sales/domestic-sales-order/internal-stock-transfer/create">Internal Stock Transfer</a>
    },
    {
      key: 'liquidation',
      label: <a href="/sales/domestic-sales-order/liquidation/create">Liquidation</a>
    },
    {
      key: 'refurbish-internal',
      label: <a href="/sales/domestic-sales-order/refurbish-internal/create">Refurbish Internal</a>
    },
    {
      key: 'refurbish-external',
      label: <a href="/sales/domestic-sales-order/refurbish-external/create">Refurbish External</a>
    }

    // {
    //   key: "domestic_offline",
    //   label: (
    //     <a href="/sales/sales-order/create/offline">
    //       Domestic Offline
    //     </a>
    //   ),
    // },
  ];
  const internationalSoMenu = [
    {
      key: 'export_online',
      label: <a href="/sales/international-sales-order/export-online/create">Export Online</a>
    },
    {
      key: 'international-stock-transfer',
      label: (
        <a href="/sales/international-sales-order/international-stock-transfer/create">International Stock Transfer</a>
      )
    },
    {
      key: 'warehouse-shipping',
      label: <a href="/sales/international-sales-order/warehouse-shipping/create">Export Online Warehouse Shipping</a>
    }
  ];
  const soDomesticGRNMenu = [
    {
      key: 'domestic_online',
      label: <a href="/sales/domestic-grn/domestic-online/create">Domestic Online</a>
    },
    {
      key: 'domestic_online_excess',
      label: <a href="/sales/domestic-grn/domestic-online-excess/create">Domestic Online Excess</a>
    },
    {
      key: 'internal-stock-transfer',
      label: <a href="/sales/domestic-grn/internal-stock-transfer/create">Internal Stock Transfer</a>
    }
  ];
  const soInternationalGRNMenu = [
    {
      key: 'export-online',
      label: <a href="/sales/international-grn/online/create">Export Online</a>
    },
    {
      key: 'international-stock-transfer',
      label: <a href="/sales/international-grn/international-stock-transfer/create">International Stock Transfer</a>
    },
    {
      key: 'export-online-wh-shipping',
      label: <a href="/sales/international-grn/warehouse-shipping/create">Export Online Warehouse Shipping</a>
    }
  ];
  if (type === 'por') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Purchase Requests
        </Typography.Title>
        <Dropdown menu={{ items: purchaseRequestMenuItems }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            New PO <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 'po') {
    return (
      <Typography.Title level={2} style={{ margin: 0 }}>
        Purchase Orders
      </Typography.Title>
    );
  }
  if (type === 's_cpo') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Customer POs
        </Typography.Title>
        <Dropdown menu={{ items: AddCpoOptions }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            Record PO <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 'po_asn') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Advance Shipment Note
        </Typography.Title>
        <Dropdown menu={{ items: asnMenu }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            Add ASN <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 'po_grn') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Goods Received Note
        </Typography.Title>
        <Dropdown disabled menu={{ items: grnMenu }}>
          <Button disabled icon={<PlusOutlined />} type="primary">
            {' '}
            Add GRN <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }

  if (type === 'poReturnOrder') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Return Order
        </Typography.Title>
        {(user?.[USER_ROLE_KEY]?.includes('SUPER_ADMIN') ||
          user?.[USER_ROLE_KEY]?.includes('RTV_DOMESTIC_BULK_CREATION')) && (
          <Dropdown menu={{ items: purchaseReturnOrderMenuItems }}>
            <Button icon={<PlusOutlined />} type="primary">
              New Return <Divider type="vertical" />
              <DownArrowHead />
            </Button>
          </Dropdown>
        )}
      </div>
    );
  }
  if (type === 's_dso') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Sales Order
        </Typography.Title>
        <Dropdown menu={{ items: domesticSoMenu }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            New Domestic SO <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 's_iso') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Sales Order
        </Typography.Title>
        <Dropdown menu={{ items: internationalSoMenu }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            New International SO <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 'so_dgrn') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Goods Received Note
        </Typography.Title>
        <Dropdown menu={{ items: soDomesticGRNMenu }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            New Domestic GRN
            <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 'so_igrn') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Goods Received Note
        </Typography.Title>
        <Dropdown menu={{ items: soInternationalGRNMenu }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            New International GRN
            <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 'inventory') {
    return (
      <>
        <Typography.Title level={2} style={{ margin: 0 }}>
          Inventory
        </Typography.Title>
        <Divider style={{ marginBottom: 0 }} />
      </>
    );
  }
  if (type === 'ro') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Return Order
        </Typography.Title>
        <Dropdown
          menu={{
            items: [
              {
                key: 'ro_dom_online',
                label: <Link to={LINKS.returnOrder.create.domesticOnline}>Domestic Online</Link>
              },
              {
                key: 'ro_dom_offline',
                label: <Link to={LINKS.returnOrder.create.domesticOffline}>Domestic Offline</Link>
              }
            ]
          }}>
          <Button icon={<PlusOutlined />} type="primary">
            {' '}
            Create RO
            <Divider type="vertical" />
            <DownArrowHead />
          </Button>
        </Dropdown>
      </div>
    );
  }
  if (type === 'users') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Users
        </Typography.Title>
        {/* <Button icon={<PlusOutlined />} type="primary" onClick={() => navigate('/users/create')}>
            {' '}
            New User
            <Divider type="vertical" />
          </Button> */}
      </div>
    );
  }
  if (type === 'cogs') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          COGS
        </Typography.Title>
      </div>
    );
  }

  if (type === 'transfer_pricing') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          Transfer Pricing
        </Typography.Title>
      </div>
    );
  }
  if (type === 'user_access_review') {
    return (
      <div className="custom_header">
        <Typography.Title level={2} style={{ margin: 0 }}>
          User Access Reviews
        </Typography.Title>
        <Button
          icon={<PlusOutlined />}
          onClick={() => navigate('/access-control/user-access-reviews/create')}
          type="primary">
          Create Review
        </Button>
      </div>
    );
  }
  return null;
};

export default TableHeaders;
